import React from 'react';
import { GoogleButtonContainer } from '../../../../features/auth/oauth/GoogleButtonContainer';
import { LinkedInButtonContainer } from '../../../../features/auth/oauth/LinkedinButtonContainer';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {},
  socialButtonsWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '20px',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
}));

export const SocialButtons: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.socialButtonsWrapper}>
      <GoogleButtonContainer />
      <LinkedInButtonContainer />
    </div>
  );
};
